import axios from 'axios';

axios.defaults.baseURL = 'https://diseasex-backend.herokuapp.com';
// axios.defaults.baseURL = 'http://localhost:5000/';
export default axios;
